module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/foVjRU/tc-custom/9781426826344.jpg?1718183631658",
      "alt": "This image is the cover for the book Italian Prince, Wedlocked Wife, Red-Hot Revenge"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Italian Prince, Wedlocked Wife, Red-Hot Revenge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A prince marries a woman for revenge, only to discover he still loves her in this sexy international romance from a "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("Single mom Lucy Abbott is working as many hours as she can, but still can barely afford to feed her baby daughter."), _c('br'), _c('br'), _vm._v("Then Prince Maximo d’Aquilla offers her millions, and a way out of her desperate life. Max whisks her away to Italy—and soon she’s totally his!"), _c('br'), _c('br'), _vm._v("Max has seduced her completely. But is he driven by revenge, or desire? And is he ruthless enough to walk away from his captive bride?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jennie Lucas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jennie Lucas's parents owned a bookstore and she grew up surrounded by books, dreaming about faraway lands. At twenty-two she met her future husband and after their marriage, she graduated from university with a degree in English. She started writing books a year later. Jennie won the Romance Writers of America’s Golden Heart contest in 2005 and hasn’t looked back since. Visit Jennie’s website at: www.jennielucas.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0